import React from 'react';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import styled, {css} from 'styled-components';
import {useDispatch, useSelector} from 'react-redux';

import {
    breakpoints,
    Flex,
    mobileMediaQuery,
    useBreakpoint,
    useIsMobile,
} from './../../styles';
import {useIsCartoonito} from '../../helpers';
import {selectAvatar} from '../../store/actions/user';

import {ReactComponent as Chevron} from './../../assets/arrow.svg';
import borderTop from '../../assets/cornered-shape-yellow.png';

const Onboarding = ({transparentHeader}) => {
    const history = useHistory();
    const isCartoonito = useIsCartoonito();
    const {t} = useTranslation();
    const isMobile = useIsMobile();
    const dispatch = useDispatch();
    const userAvatar = useSelector(state => state.user.avatar);
    const breakpoint = useBreakpoint();

    const handleSkip = () => {
        if (userAvatar === undefined) dispatch(selectAvatar(null));

        history.push('/');
    };

    return (
        <Container
            fixed={['xs', 'mobile'].includes(breakpoint)}
            width="100%"
            padding="15px"
            justifyContent="space-between"
            background={isCartoonito ? '#f6d703' : 'black'}
            cnito={isCartoonito}
        >
            <ChevronIcon
                title={t('controls.goback')}
                onClick={handleSkip}
                cnito={isCartoonito}
            />
            <Flex margin="auto">
                {isCartoonito ? (
                    <img
                        src={require('../../assets/cnito_logo_mixed.png')}
                        width={isMobile ? '214px' : '290px'}
                        height={isMobile ? '47px' : '64px'}
                        alt="Cartoonito Logo"
                    />
                ) : (
                    <img
                        src={require('../../assets/cn-logo.svg')}
                        width={isMobile ? '99px' : '132px'}
                        height={isMobile ? '58px' : '76px'}
                        alt="CN Logo"
                    />
                )}
            </Flex>
        </Container>
    );
};

const Container = styled(Flex)`
    z-index: 100;
    top: 0;
    box-sizing: border-box;
    transition: background-color 0.3s ease;
    height: 188px;
    position: fixed;

    @media screen and (max-width: ${breakpoints.mobile}px),
        screen and (max-height: ${breakpoints.mobile}px) {
        height: 120px;
    }

    ${({cnito}) =>
        cnito &&
        css`
            ::before {
                content: '';
                position: absolute;
                bottom: -21px;
                left: 0px;
                right: 0px;
                width: 100%;
                background-image: url(${borderTop});
                background-repeat: repeat-x;
                height: 22px;
                z-index: 100;
            }
        `}
    ${({fixed}) =>
        fixed &&
        css`
            position: absolute;
        `}
`;

const ChevronIcon = styled(Chevron)`
    position: absolute;
    top: 27px;
    left: 40px;
    width: 12px;
    height: auto;
    cursor: pointer;

    transform: scaleX(-1);
    path {
        fill: ${({cnito}) => (cnito ? '#000' : '#fff')};
    }

    ${mobileMediaQuery} {
        left: 33px;
    }
`;

export default Onboarding;
